import { BASKET_TYPES, selectBasketList } from 'containers/OrderDetails/basketSlice'
import { LOCATION_STATES } from 'utils/constants'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'

const NewBtn = ({ newCompany = false, action }) => {
  const list = useSelector(selectBasketList)
  const { t } = useTranslation('form')
  const { push } = useHistory()

  return <div
    className='button__newMag center'
    onClick={() => {
      if (newCompany) {
        action()
      } else if (list?.some(l => l.type === BASKET_TYPES.rent)) {
        push(window.location.pathname, LOCATION_STATES.popup('newMag'))
      } else {
        push('/shop')
      }
    }}>
    <span className='button__plus'>+</span>
    <div className='button__desc'>{t(newCompany ? 'addAnotherCompany' : 'addAnotherOrder')}</div>
  </div>
}

export default NewBtn
